import { Card, Col, Container, Row } from 'reactstrap'
import { FeatherIcons } from '../../../Utils/Constants'
import FeatherIconCardBody from './FeatherIconCardBody'
import CommonCardHeader from '../../../Utils/CommonComponents/CommonCardHeader/CommonCardHeader'

const FeatherIconsContainer = () => {
  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CommonCardHeader title={FeatherIcons} />
            <FeatherIconCardBody />
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default FeatherIconsContainer